import {useTranslation} from 'react-i18next';

import {Card} from 'components';
import {TRANSLATION_KEYS} from 'locale';
import {BillingPlatformInvoice} from 'types';

import {InvoicesGrid} from './InvoicesGrid';
import {InvoicesTable} from './InvoicesTable';

const T_KEYS = TRANSLATION_KEYS.USER.ACCOUNT.BILLING.INVOICES;

type Props = {
    invoices: BillingPlatformInvoice[];
}

export const Invoices: React.FC<Props> = ({invoices}) => {
    const {t} = useTranslation();

    return (
        <Card className='tw-mb-4'>
            <div className='tw-ts-h3-bold -md:tw-ts-h5-bold tw-mb-4'>{t(T_KEYS.TITLE)}</div>
            <InvoicesTable invoices={invoices} />
            <InvoicesGrid invoices={invoices} />
        </Card>
    );
};